import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Inspired by the 180 websites I will understand 52 academic papers in 52 weeks",
  "description": "",
  "published": "2013-10-10T00:00:00.000Z",
  "redirect_from": ["/blog/inspired-by-the-180-websites-i-will-understand-52-academic-papers-in-52-weeks/swizec/6365"],
  "categories": "52papers52weeks, Academia, Academic Papers, Academic publishing, Learning, Personal, Reading",
  "hero": "./img/images-2379.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`[`}{`This post started the challenge to understand 52 papers in 52 weeks. You can read the entries, `}<a parentName="em" {...{
          "href": "http://swizec.com/blog/category/52-papers-in-52-weeks"
        }}>{`here`}</a>{` or get notified of new posts by `}<a parentName="em" {...{
          "href": "http://swiz.ec/52papers-list"
        }}>{`email`}</a>{`]`}</em></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "640px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/88d8231e916005169bde3e57468c4ec4/c08c5/images-2379.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20150v150h401V0h-49l-48%201-2%202c-3%205-1%209%206%2012%207%204%2018%2015%2021%2021%203%207%203%2025%201%2032l-2%205%201-5v-5l-1%204c-2%207-3%208-4%207v-2l1-3c0-6-1-5-4%205l-3%208-1-10v-8a580%20580%200%2000-8%2028%20102%20102%200%2000-7%2019l-2%204v-5l2-6a70%2070%200%20007-30v-4c0-6-1-4-4%209-5%2021-10%2035-13%2043l-2%204%201-4c0-2%200-3-1-2l-1-3a567%20567%200%20007-24l1-3%201-6%201-14%201-9-2%209a349%20349%200%2000-6%2029l-5%2017c-2%209-4%2013-4%209l-1-2c-1%200-2-4-1-8%202-9%200-6-2%203-2%2010-3%2012-4%209l-2-1c-1%200-2-11%200-19v-5c-1%200-2%204-3%2015%200%205-1%208-2%209l-2%201h-1l-1-2-1-4v-5l-1%203-2%206c-2%200-4-3-4-7%200-3%200-3-1-1l-2-5-1-8v8l-1%208-2%201c-1%201-1%201-1-2a321%20321%200%2001-5-51c-1-1-2%209-2%2016%202%2021%202%2027%201%2027-1-1-1%200-1%203v3a285%20285%200%2001-8-50l-1%202h-1c-1-2-1%202-1%209l1%2011v5c0%204%200%204-3-7l-2-17c0-13-4-11-4%202l-1%208-3-18-1-6v5c0%204%200%205-2%205v4c0%203%200%204-1%202l-2-7c0-8-1-7-1%201%200%206-2%203-2-4l-1-3c-3%200%200-18%204-26%204-6%2013-15%2022-19%207-4%209-7%208-11l-1-3H0v150m151-73c-2%201-3%201-2%202l1%203c0%202%206%209%208%209l2%202v-2a55%2055%200%2001-1-9v-2l-1-2v-1h-7m247%201c0%202-3%204-4%203h-4c0%202%200%202-2%200s-2-1-4%2010c-5%2027-8%2045-6%2045l13%2012c9%2011%207%2029-2%2041l-4%205%203%201c4%201%204%201%204-2%202-5%203-7%205-7l3%201v-55a584%20584%200%2000-2-54m-241%2047l-5%202c0%201-1%202-2%201-5-1%200%204%205%206l5%203h-1l-6%203c-4%202-4%202-2%203%201%201%201%201-2%201-4%200-6%203-2%203l4-1%203-1c1%200%209-6%2011-9%202-2%202-5%202-7%201-5-1-6-10-4m-46%206l-1%205-1-1-1-1-1%203c0%204%207%2010%2012%2010l2%201c-1%201%201%202%205%202l2-1%201-2%201-2h-2v-2l-3%201c-1%201-3%202-5%201-3-1-3-1-1-1h2l-2-2c-2-1-3-2-4-1h-1c0-1%201-2%203-2l2-1-1-2c-2%200-1-2%202-3%204-1%200-8-6-8-3%200-3%200-3%206m139%2014c-38%201-46%202-49%205l-2%203-8-1-11-1h-8v1l-1%202-3%204c0%201-1%202-2%201l-2%201v2l-1-1-1-1h-4c0%201-2%201-5-1-5-2-9-3-9-1l4%201%204%203h3l2%201c2%200%200%202-3%202h-2l3%201c2%201%202%201%200%201s-2%200-1%201v2c1%201%201%201-1%201h-3l1%201-1%201c-2%201-2%201%200%202%201%202%201%202-1%203a1802%201802%200%200014-3l5-3v3c-1%203-3%205-10%209l-12%208v4c0%202%200%202-2%202-2-1-3%200-1%201v1c-11%200%204%205%2029%209%2023%204%2055%207%2056%205l11%2010c8%208%2011%2010%2012%209a761%20761%200%2001137-23c5%200%205-1-2-4-5-3-7-5-5-7%202-3%201-3-2-1l-3%202-4-2c-5-4-5-4-1-7%206-3%2012-7%2012-9%200-1%202-4%204-4%203%201%202-1-2-3-5-2-5-2-3-2s1-1-2-1a258%20258%200%2001-14-2c-2%202-4%201-4%200l-1-2-1-2c0-2-2-2-11-1l-2%202h-4l-8-1c-4%201-6%200-7-1h-2l-9-3-24-15c-3-2-5-3-8-3l-35%201m-137%2025v2c0%202%200%202-1%201l-2-2-1-1c-3%200%200%205%204%207s16%204%2013%202c-1-1%200-1%204-1%205%200%206%200%206-2h-1c0%201-6%200-8-2l-13-5-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88d8231e916005169bde3e57468c4ec4/ca0a1/images-2379.webp 223w", "/static/88d8231e916005169bde3e57468c4ec4/75680/images-2379.webp 445w", "/static/88d8231e916005169bde3e57468c4ec4/0ba47/images-2379.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88d8231e916005169bde3e57468c4ec4/853b2/images-2379.jpg 223w", "/static/88d8231e916005169bde3e57468c4ec4/0a4fe/images-2379.jpg 445w", "/static/88d8231e916005169bde3e57468c4ec4/c08c5/images-2379.jpg 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/88d8231e916005169bde3e57468c4ec4/c08c5/images-2379.jpg",
                "alt": "Reading academic papers, by joebeone",
                "title": "Reading academic papers, by joebeone",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Reading academic papers, by joebeone`}</figcaption>{`
  `}</figure></p>
    <p><a parentName="p" {...{
        "href": "http://jenniferdewalt.com/"
      }}>{`Jennifer Dewalt`}</a>{` recently finished her challenge and created 180 websites in 180 days. Kudos to her!`}</p>
    <p>{`This got me thinking, what is that one thing I have always wanted to do, but haven't had the right motivation? I already `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-year-of-750words-com-with-shiny-graphs/swizec/4378"
      }}>{`write`}</a>{` and `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/30-day-fitness-experiment-with-results/swizec/6326"
      }}>{`exercise`}</a>{` every day so that's that for the obvious challenges.`}</p>
    <p>{`But I don't read enough.`}</p>
    <p>{`Sure I probably `}<del parentName="p">{`spend`}</del>{`waste upwards of two hours a day reading things online, but that's like fast food for the brain. Whenever I hit something deeply interesting that will take more than five minutes to read I just close the tab after five paragraphs.`}</p>
    <p>{`I'm a terribly slow reader too. Last time I measured it took me half an hour to read 10 pages of Hemingway. Part of the problem is that I like reading books when I'm comfortable and then I keep dozing off no matter how much fun I'm having.`}</p>
    <p>{`Books are out of the question then. I read three or four per year, start reading six, buy eight, and that's good enough.`}</p>
    <p>{`But I've always loved reading academic papers. Those bastions of bleeding edge research, the ten page blogpost of a scientist and their team, written in that loving academic drone of a voice, with all the chest-thumping fancy words so you don't even think to doubt the author's intelligence.`}</p>
    <p>{`In my experience it takes some three to four hours of furrowed eyebrows and meaningful grunts before you understand a serious academic paper enough to explain it. Six if it's not from your field. Eight if it's biology.`}</p>
    <p>{`Biology is hard okay.`}</p>
    <p>{`But it's effort well spent! I have never walked away from an academic paper without having learned something deeply interesting and insightful.`}</p>
    <p>{`The challenge: Read and explain one paper per week for a year. 52 papers, 52 weeks.`}</p>
    <p>{`Simple.`}</p>
    <p>{`I am going to read papers from all fields. Sometimes this is going to mean extended research to figure out the backstory, other times it will be simple. But I don't know where to find all those papers.`}</p>
    <p>{`If you have an interesting paper you've been meaning to get to, but just haven't found the time. I am your man! Send me an email: `}<a parentName="p" {...{
        "href": "mailto:swizec@swizec.com"
      }}>{`swizec@swizec.com`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      